import { useState } from 'react'
import { Bell, X } from 'lucide-react'
import { enablePush, pushPermission, pushSupported } from '../lib/push'
import { useDialogs } from './ui/dialogs'

export const PUSH_DISMISS_KEY = 'fn_push_dismissed'
const DISMISS_KEY = PUSH_DISMISS_KEY

/**
 * Opt-in-Streifen für Web-Push. Erscheint nur, wo Push unterstützt wird (auf iOS:
 * installierte PWA) und die Berechtigung noch nicht entschieden ist. Der Klick auf
 * „Aktivieren" liefert die nötige Nutzergeste (iOS-Pflicht).
 */
export function PushBanner({ role }: { role: string }): React.JSX.Element | null {
  const dialogs = useDialogs()
  const [show, setShow] = useState(
    () => pushSupported() && pushPermission() === 'default' && role !== 'guest' && localStorage.getItem(DISMISS_KEY) !== '1',
  )
  const [busy, setBusy] = useState(false)

  if (!show) return null

  async function enable(): Promise<void> {
    setBusy(true)
    const res = await enablePush()
    setBusy(false)
    if (res === 'error') {
      await dialogs.alert({ title: 'Aktivieren fehlgeschlagen', message: 'Bitte später erneut versuchen.' })
      return
    }
    setShow(false)
  }
  function later(): void {
    localStorage.setItem(DISMISS_KEY, '1')
    setShow(false)
  }

  return (
    <div className="flex items-center gap-3 border-b px-3 py-2 text-sm" style={{ borderColor: 'var(--color-line)', backgroundColor: 'var(--color-accent)' + '14' }}>
      <Bell className="size-4 shrink-0" style={{ color: 'var(--color-accent)' }} />
      <span className="flex-1" style={{ color: 'var(--color-ink)' }}>
        Benachrichtigungen aktivieren? Dann bekommst du neue Nachrichten aufs Gerät.
      </span>
      <button onClick={enable} disabled={busy} className="rounded-lg px-3 py-1 text-sm font-medium text-white disabled:opacity-50" style={{ backgroundColor: 'var(--color-accent)' }}>
        Aktivieren
      </button>
      <button onClick={later} aria-label="Später" className="rounded-lg p-1 hover:bg-black/5">
        <X className="size-4" style={{ color: 'var(--color-muted)' }} />
      </button>
    </div>
  )
}
